import IconInfo from '@apollo/icons/default/IconInfo.svg';
import { Link } from '@apollo/orbit';
import React from 'react';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';
import { DocsRouter } from 'src/lib/routers';

export const PagerDutyRoutingKeyToolTip = () => {
  return (
    <Tooltip
      interactive
      label={
        <>
          <Link
            to={DocsRouter.path('NotificationSetup', {
              hash: 'pagerduty',
            })}
            isExternal
          >
            See the docs
          </Link>{' '}
          to learn how to create a Pagerduty integration key.
        </>
      }
    >
      <IconInfo className="ml-2 cursor-pointer text-secondary" />
    </Tooltip>
  );
};
